var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_477_2141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.80591C7.5 5.97751 8.1716 5.30591 9 5.30591H28.5C29.3284 5.30591 30 5.97751 30 6.80591C30 7.63431 29.3284 8.30591 28.5 8.30591H9C8.1716 8.30591 7.5 7.63425 7.5 6.80591ZM28.5 14.3059H1.5C0.671602 14.3059 0 14.9776 0 15.8059C0 16.6343 0.671602 17.3059 1.5 17.3059H28.5C29.3284 17.3059 30 16.6343 30 15.8059C30 14.9776 29.3284 14.3059 28.5 14.3059ZM28.5 23.3059H15C14.1717 23.3059 13.5 23.9775 13.5 24.8059C13.5 25.6342 14.1717 26.3059 15 26.3059H28.5C29.3284 26.3059 30 25.6342 30 24.8059C30 23.9775 29.3284 23.3059 28.5 23.3059Z",
    fill: "#4527A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_2141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.805908)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.354ade88fb703e87c9a22f4aa58b3094.svg";
export { ForwardRef as ReactComponent };